import { postRequest } from './request'

//用户使用功能次数
export const getUserNum = function (type) {
	postRequest('api/msg/clicks', {
		type: type
	}).then(res => {
		return res && res.data
	})
}
//提交用户使用功能详情
export const addUserRecord = function (title, explain, content, scale) {
	postRequest('api/msg/record', {
		uid: JSON.parse(localStorage.getItem('userinfo')).uid,
		title: title,
		explain: explain,
		content: content,
		scale: scale,
	}).then(res => {
		return res && res.data
	})
}